'use client';
import React, { useState } from 'react';

const facts = [
  {
    id: 'fact-whale-song',
    emoji: '🎵',
    title: 'What is a whale song?',
    body: 'Whales make long, beautiful sounds that travel for thousands of kilometres underwater. Scientists think they sing to talk to each other, find friends, and maybe even tell stories!',
    color: 'border-kid-dolphin/30 bg-kid-dolphin/5',
    tag: 'Wildlife',
  },
  {
    id: 'fact-current',
    emoji: '🌀',
    title: 'What is an ocean current?',
    body: "The ocean is always moving, even when it looks still. Giant rivers of water called currents flow through the sea, carrying warm and cold water around the whole planet — like the ocean's own heartbeat.",
    color: 'border-kid-blue/30 bg-kid-blue/5',
    tag: 'Environment',
  },
  {
    id: 'fact-ice',
    emoji: '🧊',
    title: 'How does ice float?',
    body: 'Ice is less dense than liquid water, so it floats on top! This is very special — most things get denser when they freeze. Arctic ice floating on the ocean helps keep the whole planet cool.',
    color: 'border-accent/30 bg-accent/5',
    tag: 'Environment',
  },
];

export default function FactCardOverlay() {
  const [selected, setSelected] = useState('fact-whale-song');

  return (
    <div className="bg-card/50 border border-border/50 rounded-2xl p-5 backdrop-blur-sm">
      <p className="text-xs font-semibold text-kid-blue uppercase tracking-widest mb-4">Ocean Facts</p>
      {/* Tab buttons */}
      <div className="flex gap-2 mb-5 flex-wrap">
        {facts?.map((f) => (
          <button
            key={`fact-tab-${f?.id}`}
            onClick={() => setSelected(f?.id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-150 ${
              selected === f?.id
                ? 'bg-kid-ocean/30 text-kid-blue border border-kid-ocean/40' :'bg-muted/30 text-muted-foreground border border-border/50 hover:text-foreground'
            }`}
          >
            <span>{f?.emoji}</span>
            <span>{f?.title?.split(' ')?.slice(0, 3)?.join(' ')}...</span>
          </button>
        ))}
      </div>
      {/* Active fact */}
      {facts?.filter(f => f?.id === selected)?.map((fact) => (
        <div key={fact?.id} className={`rounded-xl border p-5 fade-in ${fact?.color}`}>
          <div className="flex items-start gap-4">
            <span className="text-4xl flex-shrink-0">{fact?.emoji}</span>
            <div>
              <p className="text-base font-bold text-foreground mb-2">{fact?.title}</p>
              <p className="text-sm text-foreground/80 leading-relaxed">{fact?.body}</p>
              <span className="inline-block mt-3 text-[10px] font-semibold text-kid-blue bg-kid-ocean/20 border border-kid-ocean/30 px-2 py-0.5 rounded-full">
                {fact?.tag}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}